// AppProviders.jsx

import React from 'react';

// Context
import { CalendarTimelineProvider } from 'context/CalendarTimelineContext';
import { CartProvider } from 'context/CartContext';
import { CollectionProvider } from 'context/DatabaseContext';
import { EngagementProvider } from 'context/EngagementContext';
import { IconsProvider } from 'context/IconsContext';
import { LanguageProvider } from 'context/LanguageContext';
import { NavigationProvider } from 'context/NavigationContext';
import { NodePeekProvider } from 'context/NodePeekContext';
import { SketchProvider } from 'context/SketchContext';
import SketchHost from 'nodetypes/sketch/SketchHost';
import { NodeTypesProvider } from 'context/NodeTypesContext';
import { NodeWorkflowProvider } from 'context/NodeWorkflowContext';
import { OnlineProvider } from 'context/OnlineContext';
import { ProgressProvider } from 'context/ProgressContext';
import { StartupStatusProvider } from 'context/StartupStatusContext';
import { StudioProvider } from 'context/StudioContext';
import { UIProvider } from 'context/UIContext';
import { ShellChromeProvider } from 'context/ShellChromeContext';
import { UserProvider } from 'context/UserContext';
import { BaseProvider } from 'context/BaseContext';
import BaseLimitFeedbackHost from 'context/BaseLimitFeedbackHost';
import { BaseRosterProvider } from 'context/BaseRosterContext';

// Components
import { db } from 'firebaseConfig';

/**
 * AppProviders
 *
 * @returns {ReactNode} The rendered component.
 */
const AppProviders = ({ children }) => {

  // ----- RENDER ----- //

  return (
    <LanguageProvider>
      <NavigationProvider>
        <NodePeekProvider>
        <SketchProvider>
          <ProgressProvider>
            <IconsProvider>
              <CalendarTimelineProvider>
                <CartProvider>
                  <EngagementProvider>
                    <NodeWorkflowProvider>
                      <UIProvider>
                        <ShellChromeProvider>
                        <StartupStatusProvider>
                          <UserProvider>
                            <OnlineProvider>
                              <BaseProvider>
                                <BaseRosterProvider>
                                  <StudioProvider>
                                  <BaseLimitFeedbackHost />
                                  <CollectionProvider>
                                    <NodeTypesProvider db={db} subscribe={true}>
                                      <SketchHost />
                                      {children}
                                    </NodeTypesProvider>
                                  </CollectionProvider>
                                </StudioProvider>
                                </BaseRosterProvider>
                              </BaseProvider>
                            </OnlineProvider>
                          </UserProvider>
                        </StartupStatusProvider>
                        </ShellChromeProvider>
                      </UIProvider>
                    </NodeWorkflowProvider>
                  </EngagementProvider>
                </CartProvider>
              </CalendarTimelineProvider>
            </IconsProvider>
          </ProgressProvider>
        </SketchProvider>
        </NodePeekProvider>
      </NavigationProvider>
    </LanguageProvider>
  );
};

// Dev Tools
AppProviders.displayName = 'AppProviders';

export default AppProviders;
